export default __webpack_public_path__ + "static/hire_top_back-77b30057149d94f56fc985f82957c5ea.webp";